import "./MilestoneMethodology.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import PolicyIntroduction from "./sections/PolicyIntroduction";
import Deliverables from "./sections/Deliverables";
import InquiryForm from "./sections/InquiryForm";
import Footer from "@/reusable_sections/Footer";
export default function MilestoneMethodologyPage() {
  return <div>
      <Header />
      <HeroBanner />
      <PolicyIntroduction />
      <Deliverables />
      <InquiryForm />
      <Footer />
    </div>;
}